module.exports = __webpack_public_path__ + "media/images/icons/plus-614ff668dfcc6c40103ffb806e4b759d.svg";